<template>
  <aside class="sidebar" @mouseleave="closeLangMenu"
         :class="{'small-sidebar': !fullSidebar}">
    <div class="sidebar-top">
      <router-link :to="'/'">
        <!--<logo :show-full="fullSidebar"></logo>-->
        <img v-if="fullSidebar" src="../../assets/logo.svg" alt="">
        <img v-else src="../../assets/logo_small.svg" alt="">
      </router-link>
    </div>
    <nav class="sidebar-nav">
      <div class="nav-list">
        <router-link class="nav-item hint-cont"  :to="'/'">
          <button type="button">
            <home-icon></home-icon>
            <span  :class="{'btn-hint btn-hint_left btn-hint_left_small': !fullSidebar}">{{$t('menu.home')}}</span>
          </button>
        </router-link>
        <router-link class="nav-item hint-cont"  :to="'/projects'">
          <button type="button">
            <projects-icon></projects-icon>
            <span :class="{'btn-hint btn-hint_left btn-hint_left_small': !fullSidebar}">{{$t('menu.projects')}}</span>
          </button>
        </router-link>
        <!--<router-link class="nav-item hint-cont" :to="'/scripts'" tag="li">-->
          <!--<button type="button">-->
            <!--<scripts-icon></scripts-icon>-->
            <!--<span  :class="{'btn-hint btn-hint_left btn-hint_left_small': !fullSidebar}">-->
            <!--{{$t('menu.scripts')}}-->
            <!--</span>-->
          <!--</button>-->
        <!--</router-link>-->
        <router-link v-if="adminRole" class="nav-item hint-cont" :to="'/roles'" >
          <button type="button">
            <users-icon></users-icon>
            <span  :class="{'btn-hint btn-hint_left': !fullSidebar, 'btn-hint_left_small': $i18n.locale == 'en'}">
            {{$t('menu.users')}}
            </span>
          </button>
        </router-link>
        <router-link class="nav-item hint-cont" :to="'/things'" >
          <button type="button">
            <things-icon></things-icon>
            <span  :class="{'btn-hint btn-hint_left btn-hint_left_small': !fullSidebar}">
            {{$t('menu.things')}}
            </span>
          </button>
        </router-link>
        <router-link  class="nav-item hint-cont"
                      to="/journals">
          <button type="button">
            <journal-icon></journal-icon>
            <span  :class="{'btn-hint btn-hint_left btn-hint_left_small': !fullSidebar}">
              {{$t('index.journal.title')}}
            </span>
          </button>
        </router-link>
        <!--<router-link class="nav-item hint-cont" :to="'/vidgets'" tag="li">-->
          <!--<button type="button">-->
            <!--<vidgets-icon></vidgets-icon>-->
            <!--<span :class="{'btn-hint btn-hint_left': !fullSidebar}">-->
            <!--{{$t('menu.vidgets')}}-->
            <!--</span>-->
          <!--</button>-->
        <!--</router-link>-->
        <!--<router-link class="nav-item hint-cont" :to="'/dashboards'" tag="li">-->
          <!--<button type="button">-->
            <!--<dashboards-icon></dashboards-icon>-->
            <!--<span  :class="{'btn-hint btn-hint_left': !fullSidebar}">-->
            <!--{{$t('menu.dashboards')}}-->
            <!--</span>-->
          <!--</button>-->
        <!--</router-link>-->
        <!--<router-link class="nav-item hint-cont" :to="'/logs'" tag="li">-->
          <!--<button type="button">-->
            <!--<logs-icon></logs-icon>-->
            <!--<span  :class="{'btn-hint btn-hint_left': !fullSidebar}">-->
            <!--{{$t('menu.logs')}}-->
            <!--</span>-->
          <!--</button>-->
        <!--</router-link>-->
        <div @mouseenter="showLangMenu"
             @mouseleave="closeLangMenu"
             class="nav-item nav-item_lang nav-item_margin">
          <button type="button">
            <lang-icon></lang-icon>
            <span v-show="fullSidebar" class="lang-label_cont">
              <span>{{$t('menu.lang')}}:</span>
              <span class="lang-label"
                    @mouseenter="showLangMenu"
                    v-if="$i18n.locale == 'ru'">Русский</span>
              <span class="lang-label"
                    @mouseenter="showLangMenu"
                    v-if="$i18n.locale == 'en'">English</span>
            </span>
          </button>
          <lang-switcher @closeMenu="closeLangMenu"
                         @mouseleave.native="closeLangMenu"
                         :show-lang-switcher="langMenu"></lang-switcher>
        </div>
        <div @click="logout" class="nav-item hint-cont nav-item_logout">
          <button type="button">
            <logout-icon></logout-icon>
            <span  :class="{'btn-hint btn-hint_left': !fullSidebar}" >
              {{$t('menu.logout')}}
            </span>
          </button>
        </div>
      </div>
    </nav>
    <button type="button"
            @click="toggleSizeSidebar"
            class="toggle-btn">
      <toggle-icon :fill="fullSidebar ? '#C2CFE0' : '#29ABE2'"></toggle-icon>
      {{$t('menu.switchSidebar')}}
    </button>
  </aside>
</template>

<script>
  import homeIcon from '../Svg/sidebar/homeIcon'
  import scriptsIcon from '../Svg/sidebar/scriptsIcon'
  import usersIcon from '../Svg/sidebar/usersIcon'
  import thingsIcon from '../Svg/sidebar/thingsIcon'
  import vidgetsIcon from '../Svg/sidebar/vidgetsIcon'
  import dashboardsIcon from '../Svg/sidebar/dashboardicon'
  import logsIcon from '../Svg/sidebar/logsIcon'
  import toggleIcon from '../Svg/sidebar/toggleIcon'
  import logoutIcon from '../Svg/sidebar/logout'
  import langIcon from '../Svg/langIcon'
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  import logo from '../Svg/logo'
  import langSwitcher from '../langSwitcher'
  import projectsIcon from '../Svg/sidebar/projectsIcon'
  import journalIcon from '../Svg/dashboard/journalIcon'

  export default {
    name: 'sidebar',
    components: {
      homeIcon,
      scriptsIcon,
      usersIcon,
      thingsIcon,
      vidgetsIcon,
      dashboardsIcon,
      logsIcon,
      toggleIcon,
      logo,
      logoutIcon,
      langIcon,
      langSwitcher,
      projectsIcon,
      journalIcon
    },
    data() {
      return {
        langMenu: false
      }
    },
    computed: {
      ...mapState({
        fullSidebar: state => state.sidebar.showFull
      }),
      ...mapGetters({
        adminRole: 'auth/adminRole'
      })
    },
    methods: {
      ...mapMutations({
        toggleSidebar: 'sidebar/SET_SHOW_FULL'
      }),
      ...mapActions({
        logout: 'auth/logout'
      }),
      toggleSizeSidebar() {
        this.toggleSidebar(!this.fullSidebar);
        localStorage.setItem('sidebar-size', this.fullSidebar);
      },
      logout() {
        this.$store.dispatch('auth/logout');
      },
      showLangMenu() {
        this.langMenu = true
      },
      closeLangMenu() {
        this.langMenu = false
      }
    },
    mounted() {
      let sizeSidebar = localStorage.getItem('sidebar-size');
      if (!!sizeSidebar) {
        this.toggleSidebar(JSON.parse(sizeSidebar));
      }
    }
  }
</script>

<style lang="scss" >
  .sidebar {
    box-shadow: 0px 0px 30px rgba(0, 82, 127, 0.06);
    max-width: 240px;
    width: 240px;
    position: fixed;
    z-index: 10;
    left: 0;
    top: 0;
    height: 100vh;
    padding-bottom: 40px;
    display: flex;
    flex-direction: column;
    background: white;
    transition: $anim;

    .sidebar-top {
      height: 90px;
      padding: 30px;
      border-bottom: 1px solid $lightGrey;
      margin-bottom: 30px;

      img {
        width: 100%;
      }

      svg {
        max-width: 146px;
        width: 100%;
      }
    }

    .lang-label_cont {
      display: flex;
      flex-wrap: nowrap;
      white-space: nowrap;
    }

    .sidebar-nav, .nav-list {
      height: 100%;
    }

    .nav-list {
      display: flex;
      flex-direction: column;
    }

    .lang-label {
      text-decoration: underline;
      color: $lightBlue;
    }

    .nav-item {
      &:hover {
        span {
          //display: block;
        }
      }
    }

    .nav-item button{
      text-align: left;
      padding: 13px 28px;
      cursor: pointer;
      transition: $anim;
      display: flex;
      align-items: center;
      height: 50px;
      font-family: $mr;
      font-size: 14px;
      letter-spacing: 0.25px;
      color: $darkBlue;
      position: relative;
      width: 100%;

      &::before {
        content: '';
        position: absolute;
        width: 4px;
        height: 24px;
        background: $lightBlue;
        opacity: 0;
        transition: $anim;
        left: 0;
        top: 13px;
      }

      svg {
        margin-right: 18px;
        opacity: .4;
        transition: $anim;
        max-width: 22px;
        max-height: 22px;

        path {
          transition: $anim;
          fill: $darkBlue;
        }
      }

      &:hover, &:focus {
        background: $lightGrey;

        svg {
          opacity: 1;
        }

        path {
          fill: $lightBlue;
        }
      }
    }

    .nav-item_margin {
      margin-top: auto;
    }

    .nav-item_lang {
      position: relative;
    }

    .lang-switcher {
      position: absolute;
      left: 111px;
      bottom: 100%;
    }

    .router-link-exact-active button {
      font-family: $mm;

      &::before {
        opacity: 1;
      }

      svg {
        opacity: 1;

        path {
          fill: $lightBlue;
        }
      }
    }

    .toggle-btn {
      margin-top: auto;
      font-family: $mr;
      font-size: 11px;
      color: #90a0b7;
      display: flex;
      align-items: center;
      padding:0 30px;
      white-space: nowrap;
      margin-top: 18px;

      &:focus {
        border: 1px solid $lightGrey;
      }

      svg {
        margin-right: 14px;

      }
    }
  }

  .small-sidebar {
    width: 60px;

    .lang-switcher {
      position: absolute;
      left: 3px;
      bottom: 100%;
    }

    .sidebar-top {
      padding: 20px;
      padding-left: 10px;
      padding-right: 10px;
    }

    img {
      transition: none;
      max-width: 40px;
    }

    .nav-item button{
      font-size: 0;
      padding: 12px 5px;
      display: flex;
      justify-content: center;

      svg {
        margin: 0;
      }
    }

    .toggle-btn {
      font-size: 0;
      padding: 0;
      margin: 18px auto 0;
      padding-left: 14px;
    }

    .nav-item_logout  button{
      padding-right: 7px;
    }
  }
</style>
